import { Grid, Typography } from '@mui/material';
import { Control } from 'react-hook-form';
import { DeliverablesForm } from './DeliverablesForm';


interface DeliverablesProps{
    control: Control<any>
}
export const Deliverables = ({ control }: DeliverablesProps) => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <Grid container gap={'20px'} display={"flex"} flexDirection={"column"}>
            <Typography variant='lora-title-large' color={'primary'} fontWeight={'bold'}>Provide job deliverables</Typography> 
            <Typography variant='body-medium' color={'primary'} >Determine the deliverables* for the job so Talents have clear expectations of what they need to deliver by the end of the job.</Typography> 
            <DeliverablesForm control={control} />
        </Grid>
    )
}